<template>
	<v-card variant="outlined">
		<v-card-text class="d-flex flex-column align-center">
			<div class="w-100 my-3">
				<WaveformWidget
					:ref="asset.AssetID"
					:key="asset.AssetID"
					:id="asset.AssetID"
					:open-selection="true"
					@update:marker="handleUpdateMarkerValue"
					@update:region="handleUpdateRegion"
					@override:station-marker="stationID => $emit('override:stationMarker', stationID)"
				/>
			</div>

			<div class="w-100 my-3">
				<v-form>
					<v-row>
						<v-col cols="6">
							<v-row align="center">
								<v-col cols="2" class="fade-in-tab">
									<v-icon icon="mdi-circle" color="red" size="8"/>
									<label class="text-caption mr-3"> Fade In </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="fadeInModelValue"
										placeholder="Fade In"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('fadeIn', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('fadeIn')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('fadeIn')">
										Set
									</v-btn>
								</v-col>
							</v-row>

							<v-row class="d-flex align-center">
								<v-col cols="2" class="fade-in-tab">
									<label class="text-caption mr-3">Length </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="fadeInLengthModelValue"
										placeholder="Length"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('fadeInLength', value)"
									/>
								</v-col>
								<v-col cols="2" offset="2">
									<v-btn :disabled="!selectedStation">
										Set
									</v-btn>
								</v-col>
							</v-row>

							<v-row class="d-flex align-center">
								<v-col cols="2" class="fade-out-tab">
									<v-icon icon="mdi-circle" color="red" size="8"/>
									<label class="text-caption mr-3"> Fade Out </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="fadeOutModelValue"
										placeholder="Fade Out"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('fadeOut', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('fadeOut')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('fadeOut')">
										Set
									</v-btn>
								</v-col>
							</v-row>

							<v-row class="d-flex align-center">
								<v-col cols="2" class="fade-out-tab">
									<label class="text-caption mr-3"> Length </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="fadeOutLengthModelValue"
										placeholder="Length"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('fadeOutLength', value)"
									/>
								</v-col>
								<v-col cols="2" offset="2">
									<v-btn :disabled="!selectedStation">
										Set
									</v-btn>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="6">
							<v-row class="d-flex align-center">
								<v-col cols="2">
									<v-icon icon="mdi-circle" color="rgb(255, 189, 0)" size="8"/>
									<label class="text-caption mr-3"> Intro </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="introModelValue"
										placeholder="Intro"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('intro', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('intro')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('intro')">
										Set
									</v-btn>
								</v-col>
							</v-row>
							<v-row v-if="formData.intro2" class="d-flex align-center">
								<v-col cols="2">
									<v-icon icon="mdi-circle" color="rgb(255, 189, 0)" size="8"/>
									<label class="text-caption mr-3"> Intro 2 </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="intro2ModelValue"
										placeholder="Intro 2"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('intro2', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('intro2')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('intro2')">
										Set
									</v-btn>
								</v-col>
							</v-row>
							<v-row v-if="formData.intro3" class="d-flex align-center">
								<v-col cols="2">
									<v-icon icon="mdi-circle" color="rgb(255, 189, 0)" size="8"/>
									<label class="text-caption mr-3"> Intro 3 </label>
								</v-col>
								<v-col cols="5">
									<v-text-field :model-value="intro3ModelValue"
										placeholder="Intro 3"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('intro3', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('intro3')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('intro3')">
										Set
									</v-btn>
								</v-col>
							</v-row>
							<v-row v-if="!formData.intro3" class="d-flex align-center">
								<v-col offset="2">
									<v-btn
										color="secondary"
										prepend-icon="mdi-plus-circle-outline"
										:disabled="!selectedStation"
										@click="addIntro">
										Add Intro
									</v-btn>
								</v-col>
							</v-row>

							<v-row class="d-flex align-center">
								<v-col cols="2">
									<v-icon icon="mdi-circle" color="purple" size="8"/>
									<label class="text-caption mr-3"> Early Segue </label>
								</v-col>

								<v-col cols="5">
									<v-text-field :model-value="earlySegueModelValue"
										placeholder="Early Segue"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('earlySegue', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('earlySegue')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('earlySegue')">
										Set
									</v-btn>
								</v-col>
								<v-col cols="1">
									<v-btn
										:icon="assetLocked ? 'mdi-lock' : 'mdi-lock-open-variant'"
										variant="flat"
										rounded
										:disabled="!selectedStation"
										@click="toggleAssetLocked"/>
								</v-col>
							</v-row>

							<v-row class="d-flex align-center">
								<v-col cols="2">
									<v-icon icon="mdi-circle" color="green" size="8"/>
									<label class="text-caption mr-3">Segue </label>
								</v-col>
								<v-col cols="5">
									<v-text-field
										:model-value="segueModelValue"
										type="text"
										placeholder="Segue"
										variant="outlined"
										density="compact"
										hide-details
										clearable
										:disabled="!selectedStation"
										@update:model-value="value => updateFormData('segue', value)"
									/>
								</v-col>
								<v-col class="align" cols="2">
									<v-btn
										color="secondary"
										variant="outlined"
										:disabled="!selectedStation"
										@click="setMarkerToTime('segue')"
									>
										Go to
									</v-btn>
								</v-col>
								<v-col cols="2">
									<v-btn
										:disabled="!selectedStation"
										@click="setTimeToMarker('segue')">
										Set
									</v-btn>
								</v-col>
							</v-row>
						</v-col>

					</v-row>

				</v-form>
			</div>
		</v-card-text>

	</v-card>
</template>

<script>
/* Modules */
import WaveformWidget from "@/components/WaveformWidget.vue";

/* Mixins */
import DurationFormatMixin from "@/mixins/DurationFormatMixin";
import AssetProperties from "@/mixins/AssetProperties";

/* Libraries */
import emitter from "@/emitter";

/* Enums */
import POITypes from "@/enums/POITypes";

export default {
	name: "AssetManagementStationMarksTab",

	components: {WaveformWidget},

	mixins: [DurationFormatMixin, AssetProperties],

	emits: ["update:asset", "override:stationMarker"],

	data() {
		return {
			formData: {},
			payload: {},
			markerValue: null
		}
	},

	computed: {
		event() {
			return this.$store.getters.getAssetManagementEvent();
		},

		asset() {
			return this.$store.getters.getAssetManagementAsset();
		},

		selectedStation() {
			return this.$store.getters.getAssetManagementSelectedStation();
		},

		assetLocked() {
			return this.formData?.POIMarkup?.POIMarkers.find(p => p.POIType === 104)?.Static;
		},

		fadeInModelValue() {
			return this.formData.fadeIn ? this.secondsToFormat(this.formData.fadeIn, 'mm:ss') : this.formData.fadeIn;
		},

		fadeInLengthModelValue() {
			return this.formData.fadeInLength ? this.secondsToFormat(this.formData.fadeInLength, 'mm:ss') :
				   this.formData.fadeInLength;
		},

		fadeOutModelValue() {
			return this.formData.fadeOut ? this.secondsToFormat(this.formData.fadeOut, 'mm:ss') : this.formData.fadeOut;
		},

		fadeOutLengthModelValue() {
			return this.formData.fadeOutLength ? this.secondsToFormat(this.formData.fadeOutLength, 'mm:ss') :
				   this.formData.fadeOutLength;
		},

		introModelValue() {
			return this.formData.intro ? this.secondsToFormat(this.formData.intro, 'mm:ss') : this.formData.intro;
		},

		intro2ModelValue() {
			return this.formData.intro2 ? this.secondsToFormat(this.formData.intro2, 'mm:ss') : this.formData.intro2;
		},

		intro3ModelValue() {
			return this.formData.intro3 ? this.secondsToFormat(this.formData.intro3, 'mm:ss') : this.formData.intro3;
		},

		segueModelValue() {
			return this.formData.segue ? this.secondsToFormat(this.formData.segue, 'mm:ss') : this.formData.segue;
		},

		earlySegueModelValue() {
			return this.formData.earlySegue ? this.secondsToFormat(this.formData.earlySegue, 'mm:ss') :
				   this.formData.earlySegue;
		}
	},

	methods: {
		updateAsset() {
			this.payload.StationID = this.selectedStation.StationID;
			this.payload.AssetID = this.asset.AssetID;
			this.payload.POIMarkup = {
				Length: this.markers.Length,
				Path: this.markers.Path,
				POIMarkers: []
			}

			if (this.formData?.fadeIn || this.formData?.fadeInLength) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 101,
					Position: this.formData.fadeIn,
					Duration: this.formData.fadeInLength
				});
			}

			if (this.formData?.fadeOut || this.formData?.fadeOutLength) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 102,
					Position: this.formData.fadeOut,
					Duration: this.formData.fadeOutLength
				});
			}

			if (this.formData?.segue) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 103,
					Position: this.formData.segue,
				});
			}

			if (this.formData?.earlySegue) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 104,
					Position: this.formData.earlySegue,
				});
			}

			if (this.formData?.intro) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 106,
					Position: this.formData.intro
				});
			}

			if (this.formData?.intro2) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 106,
					Position: this.formData.intro2
				});
			}

			if (this.formData?.intro3) {
				this.payload.POIMarkup.POIMarkers.push({
					POIType: 106,
					Position: this.formData.intro3
				});
			}

			this.$store.dispatch("updateStationAsset", this.payload);
		},

		toggleAssetLocked() {
			let poiMarker = this.formData?.POIMarkup?.POIMarkers.find(p => p.POIType === 104);

			if (poiMarker) {
				this.formData.POIMarkup.POIMarkers.find(p => p.POIType === 104).Static = !this.assetLocked;
			}
			else {
				this.formData.POIMarkup = {
					POIMarkers: [
						{
							POIType: 104,
							Static: !this.assetLocked
						}
					]
				};
			}
		},

		initFormData() {
			this.formData = {
				fadeIn: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.FadeIn)?.Position ??
						this.asset?.POIPlaybackView?.FadeIn ??
						null,
				fadeInLength: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.FadeIn)?.Duration ??
							  null,
				fadeOut: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.FadeOut)?.Position ??
						 this.asset?.POIPlaybackView?.FadeOut ??
						 null,
				fadeOutLength: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.FadeIn)?.Duration ??
							   null,
				segue: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.Segue)?.Position ??
					   this.asset?.POIPlaybackView?.Segue ??
					   null,
				earlySegue: this.markers?.POIMarkers?.find(p => p.POIType === POITypes.EarlySegue)?.Position ??
							null
			};
			this.getPoiMarkersByType(this.markers.POIMarkers, POITypes.Intro).forEach((marker, index) => {
				if (index === 0) {
					this.formData.intro = marker.Position;
				}
				else {
					this.formData[`intro${index + 1}`] = marker.Position;
				}
			})
			if (!this.formData.intro && this.asset?.POIPlaybackView?.Intro1) {
				this.formData.intro = this.asset?.POIPlaybackView?.Intro1
			}
			if (!this.formData.intro2 && this.asset?.POIPlaybackView?.Intro2) {
				this.formData.intro2 = this.asset?.POIPlaybackView?.Intro2
			}
			if (!this.formData.intro3 && this.asset?.POIPlaybackView?.Intro3) {
				this.formData.intro3 = this.asset?.POIPlaybackView?.Intro3
			}
		},

		updateFormData(field, value) {
			value = this.formatToSeconds(value, "mm:ss");
			if ((field === "segue" || field === "intro") && value) {
				if (this.formData.fadeIn && value < this.formData.fadeIn) {
					value = this.formData.fadeIn;
				}
				else if (this.formData.fadeOut && value > this.formData.fadeOut) {
					value = this.formData.fadeOut;
				}
			}
			this.formData[field] = value;
			emitter.emit("update:marker", {
				field,
				value
			});
		},

		handleUpdateMarkerValue(value) {
			this.markerValue = value;
		},

		handleUpdateRegion({field, value}) {
			this.formData[field] = value;
		},

		setTimeToMarker(field) {
			this.formData[field] = this.markerValue;
			emitter.emit("update:marker", {
				field,
				value: this.formData[field]
			});
		},

		setMarkerToTime(field) {
			emitter.emit("update:currentMarker", this.formData[field]);
		},

		addIntro() {
			if (!this.formData.intro2) {
				this.formData.intro2 = {};
				emitter.emit("addIntro", "intro2");
			}
			else {
				this.formData.intro3 = {};
				emitter.emit("addIntro", "intro3");
			}
		}
	},

	watch: {
		markers() {
			this.initFormData();
		}
	},

	mounted() {
		this.initFormData()
		emitter.on("saveAsset", this.updateAsset);
	},

	beforeUnmount() {
		emitter.off("saveAsset", this.updateAsset);
	}
}
</script>

<style scoped lang="scss">
.fade-in-tab {
	background: linear-gradient(90deg, rgba(255, 0, 0, 0) 0%, rgba(255, 0, 0, 0.20) 100%);
}

.fade-out-tab {
	background: linear-gradient(90deg, rgba(255, 0, 0, 0.20) 0%, rgba(255, 0, 0, 0) 100%);
}

</style>